var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox pt0" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c("form-box", {
            ref: "formBox",
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "splitLine mb14" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c("div", { staticClass: "inTotal" }, [
                _vm._v("共" + _vm._s(_vm.total) + " 条"),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                { ref: "table", attrs: { data: _vm.tableData } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "消息标题",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "content",
                      label: "消息内容",
                      "min-width": "240",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cate_name",
                      label: "消息类型",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "verify",
                      label: "消息通知",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.is_subscribe === 2
                              ? _c("el-switch", {
                                  attrs: {
                                    value: 1,
                                    "active-text": "订阅",
                                    "inactive-text": "取消",
                                    disabled: true,
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                })
                              : _c("el-switch", {
                                  attrs: {
                                    "active-text": "订阅",
                                    "inactive-text": "取消",
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.messageSubscribe(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.is_subscribe,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "is_subscribe", $$v)
                                    },
                                    expression: "scope.row.is_subscribe",
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.where.page,
                  "page-sizes": [10, 15, 20],
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }